export const DataTrackerProps = [
    'domain',
    'orgName',
    'threadMode',
    'userAccount',
    'logginStatus',
    'isLogin',
    'uuid',
    'orgId',
    'version',
    'platform',
    'app',
    'qiyeAccountId',
    'mailVersion',
    'deviceId',
    '_page',
];
